import { cn } from "@qw/ui";
import type { ComponentProps, ReactNode } from "react";

import { useChatSession } from "../providers/chat-session-provider";
import { ChatClose } from "./chat-close";
import { ChatSessionSelector } from "./chat-session-selector";
import { ChatSessionTitle } from "./chat-session-title";

export interface ChatHeaderProps extends ComponentProps<"header"> {
  actions?: ReactNode;
  center?: ReactNode;
  hideSessionLabel?: boolean;
  leading?: ReactNode;
  sticky?: boolean;
}

export const ChatHeader = ({
  actions,
  center,
  className,
  hideSessionLabel = false,
  leading,
  sticky = true,
  ...props
}: ChatHeaderProps) => {
  const { onClose, supportsMultipleSessions } = useChatSession();
  const shouldShowDefaultLabel = !center && !hideSessionLabel && supportsMultipleSessions;
  const shouldShowTitle = !center && !hideSessionLabel && !supportsMultipleSessions;

  if (!leading && !actions && !center && !shouldShowDefaultLabel && !shouldShowTitle && !onClose) {
    return null;
  }

  return (
    <header className={cn("border-b bg-inherit flex-none p-2", sticky && "sticky top-0 z-10", className)} {...props}>
      <div className="bg-inherit flex h-8 items-center gap-2">
        {leading ? <div className="flex w-(--gutter) flex-none items-center justify-center">{leading}</div> : null}
        {center ? (
          <div className="min-w-0 flex-1">{center}</div>
        ) : shouldShowDefaultLabel ? (
          <div className="min-w-0 flex-1">
            <div className="-mx-3">
              <ChatSessionSelector />
            </div>
          </div>
        ) : shouldShowTitle ? (
          <div className="min-w-0 flex-1">
            <ChatSessionTitle />
          </div>
        ) : (
          <div className="flex-1" />
        )}
        {actions || onClose ? (
          <div className="flex flex-none items-center gap-2">
            {actions}
            {onClose ? (
              <div className="flex-none">
                <ChatClose />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </header>
  );
};
